import { AlertaSimplesErro } from '@/helpers/MensagemHelper';
import http from './ApiConfig';
import { Service } from './Service';
import { ConfiguracaoRelatorioRevisaoCompletaType } from '@/types/atendimentos/ConfiguracaoRelatorioRevisaoCompletaType';
import { PayloadImpressoAgenda } from '@/types/impressos/ConfiguracaoImpressoType';

export class Impresso extends Service {
  constructor() {
    super('impresso');
  }

  public GerarRelatorioPaciente(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-paciente`,
      configuracao,
      {
        ...this.GetHeader(),

        responseType: 'arraybuffer',

      },
    );
  }

  public GerarImpressoPrescricao(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-prescricao`,
      configuracao,
      {
        ...this.GetHeader(),

        responseType: 'arraybuffer',

      },
    );
  }

  public GerarImpressoReceitaControleEspecial(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-receita-controle-especial`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarRelatorioEncaminhamento(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-encaminhamento`,
      configuracao,
      {
        ...this.GetHeader(),

        responseType: 'arraybuffer',

      },
    );
  }

  public GerarRelatorioRotina(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-rotina`,
      configuracao,
      {
        ...this.GetHeader(),

        responseType: 'arraybuffer',

      },
    );
  }


  public GerarRelatorioeExamesComplementares(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-exames-complementares`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarRelatorioPrescricaoOculos(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-prescricao-oculos`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarLaudoPaciente(configuracao: any) {
    const header = {
      ...this.GetHeader(),
      responseType: 'arraybuffer',
    };

    try {
      const requisicao = http.post(
        `${this._nomeControle}/criar-e-imprimir-laudo`,
        configuracao,
        {
          ...this.GetHeader(),
          responseType: 'arraybuffer',
        },
      );
      return requisicao;
    } catch (error) {
      return AlertaSimplesErro('Erro ao Gerar Relatório', 'Nenhum dado foi recebido para gerar o relatório.');
    }
  }

  public GerarRelatorioConsulta(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-consulta`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public gerarRelatorioRevisaoCompletaAtendimentos(
    configuracaoDoRelatorio: ConfiguracaoRelatorioRevisaoCompletaType,
    pacienteId: number,
  ) {
    const url = `${this._nomeControle}/relatorio/atendimento/revisao-completa/${pacienteId}`;
    const parametros = {
      configuracaoRelatorioAtendimento: configuracaoDoRelatorio,
      modeloCabecalhoRodapeId: configuracaoDoRelatorio.modeloCabecalhoRodapeId,
      confirmarAssinatura: configuracaoDoRelatorio.confirmarAssinatura,
    };
    const configuracoes = {
      ...this.GetHeader(),
      responseType: 'arraybuffer' as const,
    };
    return http.post(url, parametros, configuracoes);
  }

  public GerarImpressoAgenda(configuracao: PayloadImpressoAgenda) {
    return http.post(
      `${this._nomeControle}/imprimir-agenda`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarRelatorioGuiaMedicamento(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-guia-medicamento`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarImpressoCartaoVacinacao(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-cartao-vacinacao`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarRelatorioCurvaCrescimento(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-relatorio-curva-crescimento`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }

  public GerarRelatorioGraficoCurvaCrescimento(configuracao: any) {
    return http.post(
      `${this._nomeControle}/imprimir-grafico-curva-crescimento`,
      configuracao,
      {
        ...this.GetHeader(),
        responseType: 'arraybuffer',
      },
    );
  }
}
